import React from 'react';
import HeaderNavbar from '../../containers/landingPage/HeaderNavbar'
import MainBannerBlue from '../../components/landingPage/Banners/BannerBlueGradient'
import Footer from '../../containers/landingPage/Footer'
import BecomeAPartnerForm from '../../containers/landingPage/BecomeAPartnerForm';
import axios from 'axios';
import { API_BASE_URL } from '../../config';

function BecomeAPartner() {

  const handleFormSubmit = (userInfo) => {

    const { name, email, phone_nb, message } = userInfo;
    
    axios.post(`${API_BASE_URL}/email/send-become-a-partner-email`, userInfo).catch(err => console.log(err));
  }

  return (
  <div>
    {window.location.pathname === "/professional/become-a-partner" && <HeaderNavbar dark aboutUs logo="white" professional/>}
    <MainBannerBlue text="Become A Partner"/>
    <BecomeAPartnerForm sendForm={handleFormSubmit}/>
    <Footer/>
  </div>
  );
}

export default BecomeAPartner;
